<div class="message-wrapper {{ isIE ? 'ie' : '' }}" *ngIf="messageDetails">
	<div class="options justify-content-between align-items-center py-2">
		<span class="float-left">{{ currentIndex }} of {{ totalMessages }}</span>
		<div class="float-right action-items">
			<i class="fa fa-trash pointer" *ngIf="inbox" (click)="deleteMessage()" appEheAnalytics [data]="analyticsData"></i>
			<i class="fas fa-reply pointer" (click)="openReplyBlock()" appEheAnalytics [data]="analyticsData"></i>
			<i
				class="fas fa-chevron-left {{ navigationDetails?.disableLeftNav ? 'disable-nav' : 'pointer' }}"
				(click)="showPreviousMessage()"
				appEheAnalytics
				[data]="analyticsData"></i>
			<i
				class="fas fa-chevron-right {{ navigationDetails?.disableRightNav ? 'disable-nav' : 'pointer' }}"
				(click)="showNextMessage()"
				appEheAnalytics
				[data]="analyticsData"></i>
		</div>
	</div>
	<div id="reply-wrapper">
		<ng-container *ngIf="showReplyBlock">
			<form [formGroup]="composeMessageForm">
				<mat-divider></mat-divider>
				<div class="reply-wrapper mt-5">
					<div class="replay-title">
						<h2>TO: {{ replyToAddress }}</h2>
						<p class="secondary-color-text">RE: {{ messageDetails[0]?.subject }}</p>
					</div>
					<div class="NgxEditor__Wrapper">
						<ngx-editor-menu id="msgBody" [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
						<ngx-editor
							[editor]="editor"
							[ngModel]="html"
							[disabled]="false"
							formControlName="msgBody"
							[placeholder]="'Enter text here...'"></ngx-editor>
						<app-error-message [control]="'msgBody'"></app-error-message>
					</div>
				</div>
				<div class="button-group-right my-3">
					<button class="button" mat-button appEheAnalytics [data]="analyticsData" (click)="sendReply()">
						<span [translate]="'messaging.message.send-button'">SEND</span>
					</button>
					<button
						class="button secondary-btn button-medium mat-stroked-button"
						mat-button
						appEheAnalytics
						[data]="analyticsData"
						(click)="cancelReplyBlock()">
						<span [translate]="'messaging.message.cancel-button'">CANCEL</span>
					</button>
				</div>
			</form>
		</ng-container>
	</div>
	<ng-container *ngFor="let message of messageDetails">
		<div class="message py-3">
			<div class="message-title clearfix">
				<h2>{{ message?.subject }}</h2>
				<span>{{ getDate(message?.postedOn) }}</span>
			</div>
			<div class="sender-info pt-4 pb-2">
				<i class="far fa-user-circle"></i>
				<p class="message-from" *ngIf="inbox">{{ message?.from }}</p>
				<p class="message-from" *ngIf="!inbox">{{ message?.from }}</p>
			</div>
			<div class="message-body">
				<div [innerHtml]="message?.body"></div>
			</div>
		</div>
	</ng-container>
</div>
